import { createStore } from '@aibees/shared/store';
import { ExportsMetadataStoreData as StoreData } from './types';

const useExportsMetadataStore = createStore<StoreData>(
  'exports-metadata',
  (set) => ({
    metadata: undefined,
    setMetadata: (metadata) => set({ metadata }),
  })
);

export default useExportsMetadataStore;
